function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m421.492 442.286h-395.218c-2.761 0-5-2.239-5-5v-18.411c0-82.843 67.157-150 150-150h105.218c82.843 0 150 67.157 150 150v18.411c0 2.762-2.239 5-5 5z",
  fill: "#524798"
})), /*#__PURE__*/React.createElement("path", {
  d: "m276.492 268.875h-79.312c82.843 0 150 67.157 150 150v18.411c0 2.761-2.239 5-5 5h79.312c2.761 0 5-2.239 5-5v-18.411c0-82.843-67.157-150-150-150z",
  fill: "#453d81"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m128.77 60.647v40.824l4 11.619h182.227l4-11.619v-40.824c-.001-33.494-27.153-60.647-60.648-60.647h-68.933c-33.494 0-60.646 27.153-60.646 60.647z",
  fill: "#d8aa8b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m258.349 0h-48.142c33.494 0 60.647 27.152 60.647 60.647v52.443h44.142l4-11.619v-40.824c0-33.495-27.152-60.647-60.647-60.647z",
  fill: "#c6865c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m312.932 135.634c-9.747 20.696-10.586 48.212 1.65 53.974 12.236 5.763 32.914-12.41 42.661-33.106s3.449-33.057-8.787-38.819c-12.237-5.763-25.777-2.745-35.524 17.951z",
  fill: "#ffcbbe"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m235.158 329.857h-22.55c-30.625 0-55.451-24.826-55.451-55.451v-103.629h133.453v103.629c-.001 30.625-24.827 55.451-55.452 55.451z",
  fill: "#eaac9d"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m250.634 170.777v103.548c0 27.676-20.249 50.616-46.739 54.832 2.865.456 5.8.7 8.793.7h22.389c30.669 0 55.532-24.862 55.532-55.532v-103.548z",
  fill: "#df9380"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m301.721 84.196h-155.676c-9.541 0-17.275 7.734-17.275 17.275v61.499c0 33.472 16.662 64.748 44.443 83.42l27.641 18.579c2.811 1.889 5.796 3.397 8.885 4.524l20.261-.618 20.634-6.408 23.919-16.077c27.78-18.672 44.443-49.948 44.443-83.42v-61.499c0-9.541-7.734-17.275-17.275-17.275z",
  fill: "#ffcbbe"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m290.72 84.196v78.774c0 33.472-16.662 64.748-44.443 83.42l-27.641 18.579c-2.811 1.89-5.802 3.397-8.891 4.524 12.216 4.455 26.052 2.947 37.167-4.524l27.641-18.579c27.78-18.672 44.443-49.948 44.443-83.42v-61.499c0-9.541-7.734-17.275-17.275-17.275z",
  fill: "#eaac9d"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m312.932 135.634c-9.747 20.696-10.586 48.212 1.65 53.974 12.236 5.763 32.914-12.41 42.661-33.106s3.449-33.057-8.787-38.819c-12.237-5.763-25.777-2.745-35.524 17.951z",
  fill: "#eaac9d"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m134.834 135.634c9.747 20.696 10.586 48.212-1.65 53.974-12.236 5.763-32.914-12.41-42.661-33.106s-3.449-33.057 8.787-38.819c12.236-5.763 25.777-2.745 35.524 17.951z",
  fill: "#ffcbbe"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 178.852,
  cy: 143.565,
  fill: "#5e54ac",
  r: 11.499
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 268.554,
  cy: 143.565,
  fill: "#5e54ac",
  r: 11.499
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m223.883 219.298c-13.146 0-25.458-6.471-32.934-17.311-2.355-3.414-1.496-8.092 1.918-10.447 3.415-2.355 8.092-1.496 10.447 1.919 4.672 6.773 12.361 10.817 20.568 10.817s15.897-4.044 20.568-10.817c2.354-3.416 7.032-4.275 10.447-1.919 3.415 2.355 4.274 7.033 1.918 10.447-7.474 10.839-19.786 17.311-32.932 17.311z",
  fill: "#e28086"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 406.535,
  cy: 435.037,
  fill: "#78d090",
  r: 76.963
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m445.894 368.885c6.869 11.518 10.825 24.988 10.825 39.372 0 42.506-34.458 76.963-76.963 76.963-14.385 0-27.84-3.957-39.358-10.826 13.428 22.517 38.016 37.606 66.137 37.606 42.506 0 76.963-34.458 76.963-76.963 0-28.122-15.088-52.724-37.604-66.152z",
  fill: "#6ec186"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m404.532 462.027c-1.908 0-3.751-.727-5.147-2.041l-34.221-32.2c-3.021-2.842-3.166-7.596-.323-10.617s7.596-3.167 10.617-.323l28.503 26.819 73.561-85.483c2.706-3.145 7.447-3.501 10.592-.794 3.144 2.705 3.5 7.447.794 10.592l-78.683 91.435c-1.337 1.554-3.251 2.494-5.298 2.601-.132.007-.264.011-.395.011z",
  fill: "#e7ecf1"
}))));

var SvgOnline = function SvgOnline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/online.291b8b30.svg";
export { ForwardRef as ReactComponent };